const GTM_IDS: Record<string, string> = {
  "turkiyeakademi.online": "GTM-P323585W",
  "panel.yes.tools": "GTM-MZXBHZPF",
};

export function getGtmId(hostname: string = window.location.hostname): string | null {
  const normalized = hostname.toLowerCase().split(":")[0];
  return GTM_IDS[normalized] ?? null;
}

export function injectGtm(gtmId: string): void {
  const script = document.createElement("script");
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;
  document.head.insertBefore(script, document.head.firstChild);

  const noscript = document.createElement("noscript");
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.cssText = "display:none;visibility:hidden";
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}

export function initGtm(): void {
  const gtmId = getGtmId();
  if (gtmId) {
    injectGtm(gtmId);
  }
}
